import { Button } from 'uikit'
import { useFetchData } from './useFetchData'

export const ExportExcel = ({ size }) => {
  const { mutate, isPending } = useFetchData(size)
  return (
    <Button loading={isPending} size="sm" width="100%" onClick={mutate}>
      Выгрузить Excel
    </Button>
  )
}
